module.exports = function(data) {
var __t, __p = '';
__p += '<div role="tabpanel" class="tab-pane ' +
((__t = ( data.name.toLowerCase().replace(/ /g, '') )) == null ? '' : __t) +
'" id="' +
((__t = ( data.id )) == null ? '' : __t) +
'">\n\n</div>\n';
return __p
}